var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",style:(_vm.pageStyle)},[_c('div',{staticClass:"page-content flex-row"},[_vm._l((_vm.componentParams),function(item){return [_c('div',{staticClass:"list-item"},[_c(item.instance,{tag:"component",attrs:{"data":item.data},on:{"navigate":_vm.listClick}})],1)]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4095f67c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/top-top.vue
// module id = null
// module chunks = 